<!--
 * @Descripttion: 我的任务计划
 * @Author: jschen
 * @Date: 2021-08-29 13:23:11
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-23 15:43:52
-->
<template>
    <div class="task-list-container">
        <div class="menu-tab-title">
            <div class="menu-box">
                <el-menu :default-active="searchOpt.originate" mode="horizontal" @select="handleMenuSelect">
                    <el-menu-item v-for="{ name, value } in taskPlanList" :key="value" :index="value">
                        {{ name }}
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="btn-group">
                <el-radio-group v-model="searchOpt.date" size="mini" @change="handleDateChange">
                    <el-radio-button v-for="({ name, value }, index) in timeRange" :key="index" :label="value">
                        {{ name }}
                    </el-radio-button>
                </el-radio-group>
                <el-button v-show="searchOpt.originate === 'WDRWJH.GJRW'" size="mini" @click="toCenterPlan">
                    中心任务
                </el-button>
            </div>
        </div>
        <div :class="['task-content', { ismore: isTaskSupervise }]">
            <el-table
                v-loading="loading"
                :data="tableData"
                style="width: 100%"
                :row-style="handleRowStyle"
                :height="isTaskSupervise ? 365 : 405"
                @row-dblclick="rowClick"
            >
                <el-table-column v-if="isTaskSupervise" key="status" prop="status" width="50" label="状态">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.status.desc" placement="top-start">
                            <img :src="require(`@/common/images/plan-task_0${scope.row.status.value}.png`)" />
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column key="originate" prop="originate" label="任务来源">
                    <template slot-scope="scope">
                        <span> {{ handelCateGoryName(scope.row.category) }}</span>
                    </template>
                </el-table-column>
                <el-table-column key="name" prop="name" label="工作名称" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                    v-if="!isTaskSupervise"
                    key="belongTo"
                    prop="belongTo"
                    label="所属计划/项目"
                    width="125px"
                ></el-table-column>
                <el-table-column
                    v-if="isTaskSupervise"
                    key="periodType"
                    prop="periodType"
                    label="任务周期类型"
                    width="110px"
                ></el-table-column>
                <el-table-column label="开始时间">
                    <template slot-scope="scope">{{ scope.row.startDate.slice(0, 11) }}</template>
                </el-table-column>
                <el-table-column label="完成时间">
                    <template slot-scope="scope">{{ scope.row.endDate.slice(0, 11) }}</template>
                </el-table-column>
                <el-table-column prop="response" label="责任人" width="70"></el-table-column>
                <el-table-column label="操作" width="90" align="center">
                    <template slot-scope="scope">
                        <div @click.stop>
                            <el-tooltip
                                :content="scope.row.originate == '项目计划' ? '进入芯计划' : '进入阳光招采'"
                                placement="top"
                            >
                                <a
                                    v-if="scope.row.originate == '项目计划'"
                                    href="http://crm.newhope.cn:8000/SSO/Login.aspx?appto=jhxt"
                                    target="_blank"
                                >
                                    <i class="iconfont icon-huibao"></i>
                                </a>
                                <a
                                    v-if="scope.row.originate == '采购计划'"
                                    href="http://crm.newhope.cn:8000/SSO/Login.aspx?appto=cggl"
                                    target="_blank"
                                >
                                    <i class="iconfont icon-huibao"></i>
                                </a>
                            </el-tooltip>
                            <template v-if="scope.row.category === 3 && !scope.row.isFlow">
                                <el-tooltip effect="dark" content="汇报" placement="top-start">
                                    <i
                                        style="margin-right:5px;"
                                        class="inline-block iconfont icon-huibao"
                                        @click="action('task-report', scope.row.id)"
                                    ></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="调整" placement="top-start">
                                    <i
                                        style="margin-right:5px;"
                                        class="inline-block iconfont icon-tiaozheng"
                                        @click="action('task-edit', scope.row.id)"
                                    ></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="取消" placement="top-start">
                                    <i
                                        class=" inline-block iconfont icon-quxiao1"
                                        @click="action('task-cancel', scope.row.id)"
                                    ></i>
                                </el-tooltip>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <div slot="append" style="width:100%;height:30px;"></div>
                <div slot="empty" class="empty">
                    <img src="@/assets/pics/no-empty.png" />
                    <span>暂无内容</span>
                </div>
            </el-table>
        </div>
    </div>
</template>

<script>
import { getMyPlanTaskList } from "@/api";
export default {
    name: "TaskList",
    data() {
        return {
            loading: false,
            searchOpt: {
                originate: "WDRWJH.XMJH",
                date: "month",
            },
            timeRange: [
                {
                    name: "今天",
                    value: "today",
                },
                {
                    name: "本周",
                    value: "thisWeek",
                },
                {
                    name: "下周",
                    value: "nextWeek",
                },
                {
                    name: "本月",
                    value: "month",
                },
            ],
            taskPlanList: [
                {
                    name: "项目计划",
                    value: "WDRWJH.XMJH",
                },
                {
                    name: "采购计划",
                    value: "WDRWJH.CGJH",
                },
                {
                    name: "总经会任务督办",
                    value: "WDRWJH.GJRW",
                },
            ],
            tableData: [],
        };
    },
    computed: {
        isTaskSupervise() {
            return this.searchOpt.originate === "WDRWJH.GJRW";
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$emit("more", this.isTaskSupervise);
            this.taskPlan();
        },
        async taskPlan() {
            this.loading = true;
            try {
                const { originate, date } = this.searchOpt;
                const { body, code, message } = await getMyPlanTaskList({
                    originate,
                    date,
                });
                if (code === "0000") {
                    this.tableData = body.list;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        toCenterPlan() {
            this.handleRouterJump(
                2,
                `${this.$config.portalTaskOrign}/#/plan-task/task-mange/my-task/my-task-list?hidePageHeader=true&activeName=center`,
                "",
                true
            );
        },
        handelCateGoryName(cateGory) {
            switch (cateGory) {
                case 1:
                    return "项目计划";
                case 2:
                    return "采购计划";
                case 3:
                    return "总经理督办";
            }
        },
        handleMenuSelect(key) {
            this.searchOpt.originate = key;
            this.$emit("more", this.isTaskSupervise);
            this.taskPlan();
        },
        handleDateChange() {
            this.taskPlan();
        },
        // 跳转操作
        action(positon, id) {
            this.handleRouterJump(
                2,
                `${this.$config.portalTaskOrign}/#/plan-task/task-mange/my-task/${positon}?hidePageHeader=true&id=${id}`,
                "",
                true
            );
        },
        rowClick(row) {
            if (row.category === 3) {
                this.handleRouterJump(
                    2,
                    `${this.$config.portalTaskOrign}/#/plan-task/task-mange/my-task/task-details/?hidePageHeader=true&id=${row.id}`,
                    "",
                    true
                );
            }
        },
        /**
         * @description: 处理行样式
         * @param {*} row
         * @return {*}
         */
        handleRowStyle(row) {
            if (row.row.overdue === 1) {
                //表示“逾期”
                return {
                    color: "#DD4F42",
                };
            }
        },
        // 查看全部
        viewAll() {
            this.handleRouterJump(
                2,
                `${this.$config.portalTaskOrign}/#/plan-task/task-mange/my-task?hidePageHeader=true`,
                "",
                true
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.task-list-container {
    .empty {
        position: relative;
        top: -50px;
    }
    /deep/ .el-loading-spinner {
        position: relative;
        top: 145px;
    }
    .menu-tab-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        width: 100%;
        .menu-box {
            margin-top: 16px;
            margin-bottom: 13px;
            /deep/ .el-menu.el-menu--horizontal {
                border: none;
            }
            /deep/ .el-menu-item {
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 72px;
                height: 24px;
                line-height: 24px;
                font-size: 12px;
                color: #666666;
                text-align: center;
                padding: 0 15px;
                margin-right: 8px;
                border-radius: 4px;
                background: #f9f9f9;
                &:last-child {
                    width: 105px;
                }
                &:hover {
                    color: #666666 !important;
                    background: #f9f9f9 !important;
                }
                &.is-active {
                    font-size: 12px;
                    color: #ffffff !important;
                    background: #47a489 !important;
                    border-radius: 4px !important;
                }
            }
        }
        .btn-group {
            /deep/ .el-button--mini {
                padding: 5px 15px;
                margin-left: 15px;
                color: #3a9d80;
                border-color: #3a9d80;
                border-radius: 4px;
            }
            /deep/ {
                .el-radio-button--mini .el-radio-button__inner {
                    padding: 5px 15px;
                }
                .el-radio-button__orig-radio:checked + .el-radio-button__inner {
                    color: #3a9d80;
                    background-color: #ffffff;
                    border-color: #dcdfe6;
                    box-shadow: none;
                }
            }
        }
        .search-box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 300px;
            .input-search {
                position: relative;
                display: flex;
                align-items: center;
                margin-left: 10px;
                & > i {
                    position: absolute;
                    left: 8px;
                    z-index: 999;
                    &::before {
                        font-size: 14px;
                        color: #a6a6a6;
                    }
                }
                /deep/ .el-input .el-input__inner {
                    padding-left: 25px;
                }
            }
        }
    }
    .task-content {
        width: 100%;
        height: 405px;
        overflow-y: auto;
        &.ismore {
            height: 365px;
        }
        /deep/ table thead {
            tr th {
                font-size: 13px;
                // font-weight: 400;
                // color: #666666;
                padding: 5px 0;
                border-bottom: none;
                background: #f9f9f9;
            }
        }
        /deep/ table tbody {
            tr td {
                font-size: 13px !important;
                border-bottom: none;
            }
        }
        /* 删除单元格底部横线 */
        /deep/ .el-table td {
            border-bottom: 0px solid #dfe6ec !important;
        }
        /deep/ .el-table tbody tr {
            &:hover {
                color: #3a9d80;
            }
        }
        /*去掉底部白线*/
        /deep/.el-table::before {
            height: 0px;
        }
    }
}
</style>
